import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFailure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 90,
	height: 44,
	viewBox: "0 0 90 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32.499 41.3729L58.2133 16.2858",
			stroke: "#FF3131",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.1268 16.2858L58.2139 42.0001",
			stroke: "#FF3131",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.0557 18.6995L89.1976 1",
			stroke: "#FF3131",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.4988 0.999999L89.1982 19.1419",
			stroke: "#FF3131",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.30176 18.6995L19.4437 1",
			stroke: "#FF3131",
			strokeOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.74488 0.999999L19.4443 19.1419",
			stroke: "#FF3131",
			strokeOpacity: .2
		})
	]
});
export default SvgFailure;
